import { Classroom } from '@/api/classroom'

const state = () => ({
    webinarRecords: [],
    webinarRecord: null,
    LoadingWebinarRecord: false,
    isSuccessWebinarRecord: true,
    messageWebinarRecord: '',
    savedIdClassroomWebinarRecord: 0,
    createdWebinarRecord: null,
})

const getters = {
    webinarRecordList: state => state.webinarRecords,
    webinarRecord: state => state.webinarRecord,
    isLoadingWebinarRecord: state => state.isLoadingWebinarRecord,
    isSuccessWebinarRecord: state => state.isSuccessWebinarRecord,
    messageWebinarRecord: state => state.messageWebinarRecord,
    savedIdClassroomWebinarRecord: state => state.savedIdClassroomWebinarRecord,
    createdWebinarRecord: state => state.createdWebinarRecord,
}

const actions = {
    async fetchAllWebinarRecords({ commit }, id) {

        commit('setWebinarRecordIsLoading', true)
        commit('setSavedIdClassroomWebinarRecord', id)
        await Classroom.webinarRecordList(id)
            .then(response => {
                commit('setWebinarRecords', response.data.data)
                commit('setWebinarRecordIsLoading', false)
            })
            .catch(error => {
                console.log(error)
                commit('setWebinarRecordIsLoading', false)
            })
    },
    async fetchDetailWebinarRecord({ commit }, id) {
        commit('setWebinarRecordIsLoading', true)
        await Classroom.webinarRecordDetail(id)
            .then(response => {
                // console.log(response)
                commit('setWebinarRecordDetail', response.data.data)
                commit('setWebinarRecordIsLoading', false)
            })
            .catch(error => {
                console.log(error)
                commit('setWebinarRecordIsLoading', false)
            })
    },
    async updateWebinarRecord({ commit }, webinarRecord) {
        const id = webinarRecord.id
        const payload = webinarRecord.payload

        await Classroom.webinarRecordEdit(id, payload)
            .then(response => {
                if (response.data.success) {
                    commit('setSuccessWebinarRecord', true)
                    commit('setMessageWebinarRecord', 'Berhasil Menambahkan Kategori')
                } else {
                    commit('setSuccessWebinarRecord', false)
                    commit('setMessageWebinarRecord', 'Terjadi Kesalahan')
                }
            })
            .catch(error => {
                commit('setSuccessWebinarRecord', false)
                commit('setMessageWebinarRecord', error.errors[0].message)
            })
    },
    async addWebinarRecord({ commit }, payload) {
        await Classroom.webinarRecordAdd(payload)
            .then(res => {
                if (res.data.success) {
                    commit('setCreatedWebinarRecord', res.data.data)
                    commit('setSuccessWebinarRecord', true)
                    commit('setMessageWebinarRecord', 'Berhasil Menambahkan Rekaman Webinar')
                } else {
                    commit('setSuccessWebinarRecord', false)
                    commit('setMessageWebinarRecord', 'Terjadi Kesalahan')
                }
            })
            .catch(error => {
                commit('setSuccessWebinarRecord', false)
                commit('setMessageWebinarRecord', error.errors[0].message)
            })
    },
    async deleteWebinarRecord({ commit }, id) {
        // console.log(id)
        await Classroom.webinarRecordDelete(id)
            .then(res => {

                if (res.data.success) {
                    commit('setSuccessWebinarRecord', true)
                    commit('setMessageWebinarRecord', 'Berhasil Menghapus Rekaman Webinar')
                } else {
                    commit('setSuccessWebinarRecord', false)
                    commit('setMessageWebinarRecord', 'Terjadi Kesalahan')
                }
            })
            .catch(error => {
                commit('setSuccessWebinarRecord', true)
                commit('setMessageWebinarRecord', error.errors[0].message)
            })
    }
}

const mutations = {
    setWebinarRecords: (state, webinarRecords) => {
        state.webinarRecords = webinarRecords
    },

    setWebinarRecordDetail: (state, webinarRecord) => {
        state.webinarRecord = webinarRecord
    },

    setWebinarRecordIsLoading: (state, isLoadingWebinarRecord) => {
        state.isLoadingWebinarRecord = isLoadingWebinarRecord
    },

    setSuccessWebinarRecord: (state, isSuccessWebinarRecord) => {
        state.isSuccessWebinarRecord = isSuccessWebinarRecord
    },

    setMessageWebinarRecord: (state, messageWebinarRecord) => {
        state.messageWebinarRecord = messageWebinarRecord
    },
    setSavedIdClassroomWebinarRecord: (state, savedIdClassroomWebinarRecord) => {
        state.savedIdClassroomWebinarRecord = savedIdClassroomWebinarRecord
    },
    setCreatedWebinarRecord: (state, webinarRecord) => {
        state.createdWebinarRecord = webinarRecord
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}